interface SaleValues {
  assetAffected: string;
  assetNumber: string;
  forSale: boolean;
  fairMarketValue: number;
  fmvDate: string;
  fmvUsage: string;
  saleStatus: string;
  saleDate: string | null;
  isSaleFeatured: boolean;
}

export const saleFieldConfiguration = [
  {
    name: "assetAffected",
    label: "Asset Affected",
    type: "select",
    options: [
      { label: "Truck", value: "Truck" },
      { label: "Trailer", value: "Trailer" },
    ],
    validation: { required: "Asset Affected is required" },
  },
  {
    name: "assetNumber",
    label: "Asset Number",
    type: "combo",
    dataKey: "assets",
    validation: { required: "Asset Number is required" },
  },
  {
    name: "forSale",
    label: "For Sale",
    type: "select",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  },
  {
    name: "fairMarketValue",
    label: "Fair Market Value",
    type: "number",
    validation: { required: "Fair Market Value is required" },
  },
  {
    name: "fmvDate",
    label: "FMV Date",
    type: "date",
    validation: { required: "FMV Date is required" },
  },
  {
    name: "fmvUsage",
    label: "FMV Usage",
    type: "text",
  },
  {
    name: "saleStatus",
    label: "Sale Status",
    type: "select",
    options: [
      { label: "Listed", value: "LISTED" },
      { label: "Sold", value: "SOLD" },
      { label: "Pending", value: "PENDING" },
    ],
  },
  {
    name: "saleDate",
    label: "Sale Date",
    type: "date",
  },
  {
    name: "isSaleFeatured",
    label: "Is Sale Featured",
    type: "select",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  },
];

export const saleInitialValues: SaleValues = {
  assetAffected: "",
  assetNumber: "",
  forSale: false,
  fairMarketValue: 0,
  fmvDate: "",
  fmvUsage: "",
  saleStatus: "",
  saleDate: null,
  isSaleFeatured: false,
};

export const makeFieldConfigDynamic = (
  fields: any[],
  setFieldState: (type: string) => void,
  assetAffected: string
) => {
  return fields.map((field) => {
    if (field.name === "assetAffected") {
      return {
        ...field,
        onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
          setFieldState(event.target.value),
      };
    } else if (field.name === "assetNumber") {
      return {
        ...field,
        disabled: assetAffected === "",
      };
    }
    return field;
  });
};

export const updateSaleFieldConfiguration = [
  {
    name: "assetAffected",
    label: "Asset Affected",
    type: "select",
    options: [
      { label: "Truck", value: "Truck" },
      { label: "Trailer", value: "Trailer" },
    ],
    validation: { required: "Asset Affected is required" },
  },
  {
    name: "assetNumber",
    label: "Asset Number",
    type: "combo",
    dataKey: "assets",
    validation: { required: "Asset Number is required" },
  },
  {
    name: "forSale",
    label: "For Sale",
    type: "select",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  },
  {
    name: "fairMarketValue",
    label: "Fair Market Value",
    type: "number",
    validation: { required: "Fair Market Value is required" },
  },
  {
    name: "fmvDate",
    label: "FMV Date",
    type: "date",
    validation: { required: "FMV Date is required" },
  },
  {
    name: "fmvUsage",
    label: "FMV Usage",
    type: "text",
  },
  {
    name: "saleStatus",
    label: "Sale Status",
    type: "select",
    options: [
      { label: "Listed", value: "LISTED" },
      { label: "Sold", value: "SOLD" },
      { label: "Pending", value: "PENDING" },
    ],
  },
  {
    name: "saleDate",
    label: "Sale Date",
    type: "date",
  },
];
